import type { Color } from "../../types";
import type { HasAverageColor } from "../HasAverageColor";
import type { HasBackgroundColor } from "../HasBackgroundColor";
import type { VirtualViewportPixelAccessor } from "../VirtualViewportPixelAccessor";
import { AbstractVirtualPixelDecorator } from "./AbstractVirtualPixelDecorator";

/**
 * Random virtual pixel decorator.
 */
export class RandomVirtualPixel<
  DecoratedType extends VirtualViewportPixelAccessor &
    HasAverageColor &
    HasBackgroundColor
> extends AbstractVirtualPixelDecorator<DecoratedType> {
  /**
   * @inheritDoc
   */
  getVirtualPixelColor(): Color {
    return this.decorated.getPixelColor(
      Math.floor(Math.random() * this.width),
      Math.floor(Math.random() * this.height)
    );
  }
}
